import { useContext } from "react";
import { useLocation, Link } from "react-router-dom";
import {
  Toolbar,
  Box,
  List,
  ListItem as MaterialListItem,
  Drawer,
  ListItemButton,
  ListItemIcon as MaterialListItemIcon,
  ListItemText as MaterialListItemText,
  // Link,
  Stack,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import _ from "lodash";

import { AppContext } from "context";
import { OverviewIcon } from "./OverviewIcon";
import { MediaMaterialIcon } from "./MediaMaterialIcon";
import { SoftwareIcon } from "./SoftwareIcon";
import { PatternIcon } from "./PatternIcon";
import { DocumentIcon } from "./DocumentIcon";
import { ProductIcon } from "./ProductIcon";
import { Footer } from "./Footer";
import { accessControl } from "utils";

const drawerWidth = 245;
const ListItem = styled(MaterialListItem)(({ theme }) => ({
  "&& .Mui-selected": {
    backgroundColor: theme.palette.secondary.main,
    color: "#FFFFFF",
    font: "normal normal bold 16px/38px Ubuntu",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      opacity: 0.78,
      font: "normal normal bold 16px/38px Ubuntu",
    },
  },
}));
const ListItemIcon = styled(MaterialListItemIcon)(({ theme }) => ({
  minWidth: "0",
  marginRight: theme.spacing(1),
}));
const ListItemText = styled(MaterialListItemText)(() => ({
  font: "normal normal normal 16px/38px Ubuntu",
  color: "1B0B38",
}));

export const Sidebar = () => {
  const theme = useTheme();
  const location = useLocation();
  const { userInfo } = useContext(AppContext);
  const roleList = _.get(userInfo, "roleList", []);
  const isPartner = accessControl.isPartner(roleList);
  const isInternal = accessControl.isInternal(roleList);
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: "border-box",
        },
      }}
    >
      <Toolbar />
      <Stack
        direction="column"
        spacing={0}
        justifyContent="space-between"
        sx={{
          height: "100%",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{ overflow: "auto", paddingTop: theme.spacing(3), flexGrow: 1 }}
        >
          <List>
            <ListItem>
              <ListItemButton
                component={Link}
                to="/overview"
                selected={location.pathname === "/overview"}
              >
                <ListItemIcon>
                  <OverviewIcon hover={location.pathname === "/overview"} />
                </ListItemIcon>
                <ListItemText>Overview</ListItemText>
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton
                component={Link}
                to="/media_material"
                selected={location.pathname === "/media_material"}
              >
                <ListItemIcon>
                  <MediaMaterialIcon
                    hover={location.pathname === "/media_material"}
                  />
                </ListItemIcon>
                <ListItemText>Media Material</ListItemText>
              </ListItemButton>
            </ListItem>
            {accessControl.canAccessLicenseFeature(roleList) ? (
              <ListItem>
                <ListItemButton
                  component={Link}
                  to="/product_license"
                  selected={location.pathname === "/product_license"}
                >
                  <ListItemIcon>
                    <ProductIcon
                      hover={location.pathname === "/product_license"}
                    />
                  </ListItemIcon>
                  <ListItemText>Product License</ListItemText>
                </ListItemButton>
              </ListItem>
            ) : null}
            {isPartner || isInternal || _.get(userInfo, "hasLicense", false) ? (
              <>
                <ListItem>
                  <ListItemButton
                    component={Link}
                    to="/file/software"
                    selected={location.pathname === "/file/software"}
                  >
                    <ListItemIcon>
                      <SoftwareIcon
                        hover={location.pathname === "/file/software"}
                      />
                    </ListItemIcon>
                    <ListItemText>Software</ListItemText>
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    component={Link}
                    to="/file/pattern"
                    selected={location.pathname === "/file/pattern"}
                  >
                    <ListItemIcon>
                      <PatternIcon
                        hover={location.pathname === "/file/pattern"}
                      />
                    </ListItemIcon>
                    <ListItemText>Pattern</ListItemText>
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    component={Link}
                    to="/file/document"
                    selected={location.pathname === "/file/document"}
                  >
                    <ListItemIcon>
                      <DocumentIcon
                        hover={location.pathname === "/file/document"}
                      />
                    </ListItemIcon>
                    <ListItemText>Document</ListItemText>
                  </ListItemButton>
                </ListItem>
              </>
            ) : null}
          </List>
        </Box>
        <Footer />
      </Stack>
    </Drawer>
  );
};
